const courses = {
  git_basic: {
    id: "git_basic",
    title: "Basic Git & Github",
    thumbnail: "https://learn-cf.ni.com/products/Git_and_GitHub.PNG",
  },
  js_basic: {
    id: "js_basic",
    title: "Basic Java Script",
    thumbnail:
      "https://imagedelivery.net/5MYSbk45M80qAwecrlKzdQ/7ca1b892-411f-4f4a-a5d3-82519495ae00/preview",
  },
  ts_basic: {
    id: "ts_basic",
    title: "Basic Type Script",
    thumbnail:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/2048px-Typescript_logo_2020.svg.png",
  },
  react_basic: {
    id: "react_basic",
    title: "Basic React",
    thumbnail: "https://reactnative.dev/img/header_logo.svg",
  },
  rn_basic: {
    id: "rn_basic",
    title: "Basic React Native",
    thumbnail: "https://reactnative.dev/img/header_logo.svg",
  },
  rn_intermediate: {
    id: "rn_intermediate",
    title: "Intermediate React Native",
    thumbnail: "https://reactnative.dev/img/header_logo.svg",
  },
  rn_advanced: {
    id: "rn_advanced",
    title: "Advanced React Native",
    thumbnail: "https://reactnative.dev/img/header_logo.svg",
  },
  firebase: {
    id: "firebase",
    title: "Firebase",
    thumbnail: "https://logowik.com/content/uploads/images/firebase.jpg",
  },
};

export default courses;
